// Normalise API errors (Axios/FastAPI) to a plain string for toasts / UI.
// FastAPI 422 returns {detail: [{msg, loc, type, input, url}, ...]} which crashes React if rendered raw.
export const errMsg = (err, fallback = 'Something went wrong') => {
  const d = err?.response?.data?.detail ?? err?.response?.data ?? err?.message;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x === 'string' ? x : x?.msg || JSON.stringify(x))).join('; ');
  if (typeof d === 'object') return d.msg || d.detail || JSON.stringify(d);
  return String(d);
};
